// extracted by mini-css-extract-plugin
export default {"ProductsPageCont":"Products_ProductsPageCont__FGBDE","ProductsPage":"Products_ProductsPage__IcUUc"};